import { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { HealthCardModule } from '@estercare/ester-shared'
import { useGetHealthPlanCardByModuleQuery } from '../../api/ester-b2b-api/private/healthPlan/healthPlanQueries'
import { HealthPlanCard } from '../healthPlan/healthPlanCard/HealthPlanCard'
import { HealthPlanMobileCard } from '../healthPlan/healthPlanCard/HealthPlanMobileCard'
import { Arrow } from '../icons/Arrow'
import { BodyMedium } from '../styles/Typography'
import { theme } from '../../theme/theme'
import { useWindowWidth } from '../../hooks/useWindowWidth'
import { isTabletOrMobile } from '../../utils/devices'
import { Modal } from '../modals/Modal'

export const ScreeningHealthPlanRecommendations = ({ module }: { module: HealthCardModule }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const width = useWindowWidth()
  const isCompact = isTabletOrMobile(width)
  const { data: card } = useGetHealthPlanCardByModuleQuery(module)

  if (!card || card.content.length === 0) {
    return null
  }

  const handleClose = () => setIsOpen(false)

  return (
    <Container>
      <HelperText>{t('employee.screening.recommendationsHelperText')}</HelperText>
      <ToggleButton type="button" aria-expanded={isOpen} onClick={() => setIsOpen((open) => !open)}>
        {t(isOpen ? 'employee.screening.hideRecommendations' : 'employee.screening.showRecommendations')}
        <Arrow size={20} color={theme.color.plumMid} left={isOpen} />
      </ToggleButton>
      {isCompact ? (
        <HealthPlanMobileCard card={card} isOpen={isOpen} onClose={handleClose} />
      ) : (
        isOpen && (
          <Modal onClose={handleClose} noPadding maxWidth="50vw" height="65vh">
            <HealthPlanCard card={card} isExpanded onCardClick={() => {}} onClose={handleClose} />
          </Modal>
        )
      )}
    </Container>
  )
}

const Container = styled.div`
  text-align: left;
`

const HelperText = styled(BodyMedium)`
  color: ${theme.color.grey5};
  max-width: 600px;
  margin-bottom: ${theme.spacing.small}px;
`

const ToggleButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.tiny}px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${theme.color.plumMid};
  font-family: ${theme.font.body};
  font-size: ${theme.fontSize.default}px;
  font-weight: 500;
`
